import { gql } from "graphql-request";

const SERVER_DELETE_FEEDBACK = gql`
  mutation SERVER_deleteFeedbackAnswer($input: [ID!]!) {
    deleteFeedback(input: $input)
  }
`;
export default SERVER_DELETE_FEEDBACK;